import React from 'react'
import AnsUser from '../../ansuser/AnsUser'
import NavPatient from '../../patients/navPatien/NavPatient'

function CommentPatient() {
    return (
        <div className='global-page'>
            <NavPatient menu={'ans'} />
            <AnsUser roleUser={'Patient'} />
        </div>
    )
}

export default CommentPatient